const style = (theme) => {
  const output = {
    root: {
      extend: theme.smallWrapper,
    },
    title: {
      color: theme.colors[4],
      fontFamily: theme.fonts[1],
      fontWeight: 100,
      lineHeight: 1,
      fontSize: '5vw',
      marginBottom: 60,
    },
    content: {
      display: 'flex',
    },
    sidebar: {
      width: 150,
      '& ul': {
        display: 'flex',
        flexDirection: 'column',
        '& li:not(:last-child)': {
          marginBottom: 10,
        },
      },
      '& button': {
        color: theme.colors[1],
        fontFamily: theme.fonts[1],
        cursor: 'pointer',
        fontSize: 20,
        opacity: 0.4,
        lineHeight: 1,
        fontWeight: 300,
        transition: `all 0.75s ${theme.easings.garret}`,
        '&$yearActive': {
          pointerEvents: 'none',
          opacity: 1,
        },
      },
    },
    yearActive: {},
    slides: {
      flex: 1,
      position: 'relative',
      zIndex: 1,
      touchAction: 'pan-y',
      '&:before': {
        content: '""',
        position: 'relative',
        zIndex: 1,
        display: 'block',
        width: '100%',
        paddingBottom: '50%',
      },
    },
    slide: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 1,
    },
    left: {
      flex: 1,
    },
    right: {
      width: '24vw',
      marginLeft: 40,
    },
    buttons: {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      display: 'flex',
      '& > *:not(:last-child)': {
        marginRight: 10,
      },
      '& button': {
        cursor: 'pointer',
        width: 50,
        height: 50,
        backgroundColor: theme.colors[1],
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: `all 0.75s ${theme.easings.garret}`,
        backfaceVisibility: 'hidden',
        willChange: 'transform',
        '&::before': {
          content: '""',
          display: 'block',
          width: 0,
          height: 0,
          borderStyle: 'solid',
          borderWidth: '4px 0 4px 6px',
          borderColor: `transparent transparent transparent ${theme.colors[3]}`,
          backfaceVisibility: 'hidden',
          willChange: 'transform',
          transition: `all 0.75s ${theme.easings.garret}`,
        },
      },
    },
    prev: {
      '&::before': {
        borderWidth: '4px 6px 4px 0 !important',
        borderColor: `transparent ${theme.colors[3]} transparent transparent !important`,
      },
    },
    wrapperImage: {
      position: 'relative',
      zIndex: 1,
      marginLeft: 'auto',
      marginBottom: 20,
      '&:before': {
        content: '""',
        position: 'relative',
        zIndex: 1,
        display: 'block',
        width: '100%',
        paddingBottom: '70%',
      },
    },
    image: {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 20,
      overflow: 'hidden',
    },
    yearLeft: {
      position: 'absolute',
      zIndex: 1,
      top: -20,
      left: 0,
      transform: 'translateX(-120%)',
      fontSize: '20vw',
      color: theme.colors[1],
      '-webkit-text-fill-color': 'transparent',
      '-webkit-text-stroke-width': '1px',
      '-webkit-text-stroke-color': theme.colors[1],
      fontFamily: theme.fonts[1],
    },
    yearBottom: {
      position: 'absolute',
      zIndex: 1,
      bottom: 0,
      right: 0,
      transform: 'translateY(100%)',
      fontSize: '20vw',
      color: theme.colors[1],
      '-webkit-text-fill-color': 'transparent',
      '-webkit-text-stroke-width': '1px',
      '-webkit-text-stroke-color': theme.colors[1],
      fontFamily: theme.fonts[1],
    },
    info: {
      display: 'flex',
      '& h3': {
        color: theme.colors[1],
        fontFamily: theme.fonts[1],
        fontWeight: 100,
        lineHeight: 1,
        fontSize: '3vw',
        marginBottom: 40,
      },
      '& p': {
        color: theme.colors[1],
        fontWeight: 300,
        fontSize: 17,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    slides: {
      '&:before': {
        paddingBottom: '110%',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 60,
      marginBottom: 30,
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
    },
    sidebar: {
      position: 'relative',
      zIndex: 2,
      width: '50%',
      marginTop: 10,
      marginBottom: 40,
      marginLeft: 'auto',
      marginRight: 'auto',
      overflow: 'hidden',
      '& ul': {
        flexDirection: 'row',
        transition: `all 0.75s ${theme.easings.garret}`,
        transform: (props) => `translateX(-${33.33 * props.index}%)`,
        '& li': {
          flex: '0 0 33.33%',
          textAlign: 'center',
        },
        '& li:not(:last-child)': {
          marginBottom: 0,
          marginRight: 0,
        },
        '& button': {
          fontSize: 25,
        },
      },
    },
    slides: {
      '&:before': {
        paddingBottom: '190%',
      },
    },
    slide: {},
    left: {
      width: '100%',
    },
    right: {
      width: '80%',
      marginLeft: 0,
    },
    info: {
      flexDirection: 'column',
      '& h3': {
        fontSize: 45,
      },
    },
    yearLeft: {
      display: 'none',
    },
    yearBottom: {
      display: 'none',
    },
    buttons: {
      top: -80,
      width: '100%',
      '& > *': {
        '&:not(:last-child)': {
          marginRight: 'auto',
        },
      },
    },
  }

  return output
}

export default style
